import { IDomainVerify } from './../../../interfaces/pages/abm/domain-verify.interface';
import { OptionAbmMenu } from './../../../enums/shared/menu-home.enum';
import { LocalStorageService } from "./../local-storage/local-storage.service";
import { timeout } from "rxjs/operators";
import { IMenuRegion } from "./../../../interfaces/shared";
import {BehaviorSubject, Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { EfxDataSource } from "@signal/component-library/efx-data-table";
import {I_profilePayload, I_profileResponse} from "../../../interfaces/pages/abm";
import { GfdService } from "../gfd/gfd.service";
import { RdsService } from "../../api/rds/rds.service";

@Injectable({
  providedIn: "root",
})
export class AbmService {

  // Almacena json con todos los menus de la region
  private _Menu$: BehaviorSubject<IMenuRegion[]> = new BehaviorSubject(null);
  // Menu item nuevo o editado de la pantalla de creacion.
  private _MenuSelected$: BehaviorSubject<IMenuRegion> = new BehaviorSubject(null);
  // Configuración seleccionada para GFD
  public selectedConfig: string = null;
  // Comentario de la configuración seleccionada
  public selectedConfigComment: string = null;


  get getMenuData(): IMenuRegion[] {
    return this._Menu$.getValue();
  }

  set setMenuData(menu: IMenuRegion[]) {
    this._Menu$.next(menu);
  }

  get menuSelectedData(): IMenuRegion {
    return this._MenuSelected$.getValue();
  }

  set setMenuSelect(menu: IMenuRegion) {
    this._MenuSelected$.next(menu);
  }

  get menuSelected$(): Observable<IMenuRegion> {
    return this._MenuSelected$.asObservable();
  }

  get country(): string {
    return this.localStorageService.getRegionSeleccionada.getCode()?.toUpperCase();
  }

  get isAbmPublic(): boolean {
    return this.localStorageService.getMenuApp?.title === OptionAbmMenu.FUENTES_VIP;
  }

  get tituloTipoFlujo() {
    if (this.localStorageService.getMenuApp?.title === OptionAbmMenu.FUENTES_INT) {
      return 'interno'
    } else {
      if (this.localStorageService.getMenuApp?.title === OptionAbmMenu.RDS) {
        return 'interno RDS'
      } else {
        return 'Vip';
      }
    }
  }

  get isConfiguradorVip(): boolean {
    return this.localStorageService.getMenuApp?.title === OptionAbmMenu.FUENTES_VIP;
  }

  get isRDS(): boolean {
    // Verificar tanto el título del menú como el flag esInternoRDS
    return this.localStorageService.getMenuApp?.title === OptionAbmMenu.RDS ||
           this.localStorageService.esInternoRDS === true;
  }


  constructor(
    private localStorageService: LocalStorageService,
    private http: HttpClient,
    private gfdService: GfdService,
    private rdsService: RdsService
  ) { }

  saveStruct(body) {
    // Obtener la configuración seleccionada
    const config = this.selectedConfig;

    // Agregar el comentario al body si existe
    if (this.selectedConfigComment) {
      body.comentarios = this.selectedConfigComment;
    }

    // Obtener dominio y subdominio del menu seleccionado
    const menuSelected = this.menuSelectedData;
    if (!menuSelected || !menuSelected.domainJO || !menuSelected.subDomainJO) {
      throw new Error('No hay dominio/subdominio seleccionado');
    }

    const { domainJO, subDomainJO } = menuSelected;

    // Log para depuración
    console.log('[AbmService.saveStruct] isRDS:', this.isRDS);
    console.log('[AbmService.saveStruct] esInternoRDS:', this.localStorageService.esInternoRDS);
    console.log('[AbmService.saveStruct] menuApp.title:', this.localStorageService.getMenuApp?.title);
    console.log('[AbmService.saveStruct] config:', config);
    console.log('[AbmService.saveStruct] comentarios:', this.selectedConfigComment);
    console.log('[AbmService.saveStruct] body con comentarios:', body);

    // Si es RDS, usar el servicio RDS, de lo contrario usar el servicio GFD
    if (this.isRDS) {
      console.log('[AbmService.saveStruct] Usando RDS Service');
      // Para RDS usamos chargeRdsGfd - la collection es la combinación de domainJO_subDomainJO
      const collection = `${domainJO}_${subDomainJO}`;
      console.log('[AbmService.saveStruct] Collection:', collection);
      return this.rdsService.chargeRdsGfd(collection, config, body);
    } else {
      console.log('[AbmService.saveStruct] Usando GFD Service');
      // Usar el servicio GFD para guardar la estructura con la configuración
      return this.gfdService.chargeGfd(domainJO, subDomainJO, body, config);
    }
  }

  getSources() {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_GCP"]
      : "";

    let tipoColeccion: string = "";
    const urlFoldersMenu = this.localStorageService.configInit['F_URL_FOLDERS_MENU'];
    if (this.localStorageService.esInternoRDS){
      tipoColeccion="_RDS"
    }

    let urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_OKTA_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const url = String(environment.IS_LOCAL.toLowerCase()) === "true" ?
    `assets/mock/${this.country.toLowerCase()}/sources/source.json`
    :`${urlBaseApi}${rutaMicroservicio}${urlFoldersMenu}/${this.country}${tipoColeccion}`;
    return this.http
      .get<IDomainVerify[]>(url)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  saveColeccionesRegion(dominio: string, subdominio: any) {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_GCP"]
      : "";

    let tipoColeccion: string="";
    const urlFoldersMenu = this.localStorageService.configInit['F_URL_FOLDERS_MENU'];
    if (this.localStorageService.esInternoRDS){
      tipoColeccion="_RDS"
    }

    let bodyColeccion:any = { "domain": dominio, 'subdomains': subdominio };

    let urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_OKTA_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const url = `${urlBaseApi}${rutaMicroservicio}${urlFoldersMenu}/charge/${this.country}${tipoColeccion}${this.isAbmPublic ? '_VIP' : ''}`;
    return this.http.post(url, bodyColeccion).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  generaJsonMenu(itemMenuSelected: IMenuRegion, eliminar: boolean = false): { items: IMenuRegion[] } {
    const returnBody: IMenuRegion[] = [];
    const menuData = this.getMenuData || [];
    const findMenu = menuData.find(menu => menu.domainJO === itemMenuSelected.domainJO && menu.subDomainJO === itemMenuSelected.subDomainJO);

    if (!!findMenu) {
      for (const menu of [...menuData]) {
        if (menu.domainJO === itemMenuSelected.domainJO && menu.subDomainJO === itemMenuSelected.subDomainJO) {
          if (!eliminar) {
            returnBody.push(itemMenuSelected);
          }
        } else {
          returnBody.push(menu);
        }
      }
    } else {
      returnBody.push(...menuData);
      returnBody.push(itemMenuSelected);
    }
    return { items: returnBody }
  }

  validaTimeStampResponse(data: string): boolean {
    // Validar que data existe y es un string
    if (!data || typeof data !== 'string') {
      console.warn('[AbmService.validaTimeStampResponse] Data inválido:', data);
      return false;
    }

    // Validar que el formato contiene paréntesis
    if (!data.includes('(') || !data.includes(')')) {
      console.warn('[AbmService.validaTimeStampResponse] Formato inválido, no contiene paréntesis:', data);
      // Si no tiene el formato esperado pero es un string válido, considerarlo como éxito
      return true;
    }

    try {
      const timeStamp = data.split('(')[1].split(')')[0];
      return timeStamp ? !!new Date(timeStamp) : false;
    } catch (error) {
      console.error('[AbmService.validaTimeStampResponse] Error al procesar timestamp:', error, 'Data:', data);
      return false;
    }
  }

}
@Injectable({
  providedIn: "root",
})
export class EfxClientSortingDataSource extends EfxDataSource {
  cache: any;
  sortingField: string | undefined = '';
  sortingDirection: string | undefined = 'asc';

  /** Manually add data to the data source */
  setData(_data: any) {
    this.cache = _data;
    this.query();
  }

  /**
   * @method updates the data in the datasource
   * The method is obliged to do two things:
   *   * set this.*originalRows* with the data
   *   * set *this.totalRows* with the total number of rows on the server
   */
  query() {
    if (this.cache) {
      this.cache = this.sortTheCache(this.cache);

      this.originalRows = this.cache;
      this.setTotalRows(this.originalRows?.length);
    }
  }

  /**
   * @method re-runs the last query, with some attributes of the request having changed (e.g. current page).
   */
  refresh() {
    this.query();
  }

  sortTheCache(data: any[]): any[] {
    const newData = [...data];

    Object.keys(this.currentSort).forEach((fieldName: string, index) => {
      this.sortingField = fieldName;
      this.sortingDirection = this.currentSort[fieldName];
    });
    if (this.sortingField && this.sortingDirection) {
      newData.sort(this.compareFn.bind(this));
    }
    return newData;
  }

  compareFn(a: any, b: any) {
    if (this.sortingField) {
      if (a[this.sortingField] < b[this.sortingField]) {
        return this.sortingDirection === 'asc' ? -1 : 1;
      }
      if (a[this.sortingField] > b[this.sortingField]) {
        return this.sortingDirection === 'asc' ? 1 : -1;
      }
    }
    return 0;
  }
}
